module.exports = __webpack_public_path__ + "media/images/pages/ai/icon-curated-5432a84687862eef8d3c0b14a2a80257.svg";